import state from './userfeedback.state'
import mutations from './userfeedback.mutations'
import actions from './userfeedback.actions'

export default {
  state,
  mutations,
  actions
}
